export default "__VITE_ASSET__a9c9b1f9__"